import { styled } from '@components-shared/src/stitches';

export const inputDefaultStyles = {
  display: 'flex',
  boxSizing: 'border-box',
  backgroundColor: '$neutral50',
  border: '1px solid $neutral300',
  borderRadius: 6,
  fontFamily: '$base',
  fontWeight: 400,
  color: '$neutral800',
  gap: 8,
  outline: 'none',

  '&:placeholder': {
    color: '$neutral400',
  },

  '&:focus': {
    backgroundColor: '$neutral50',
    outline: '2px solid $neutral800',
    borderColor: 'transparent',
  },

  '&:disabled': {
    border: 'none',
    color: '$neutral800',
    opacity: 0.5,
  },

  variants: {
    hasError: {
      true: {
        backgroundColor: '$destructive50',
        outline: '1px solid $destructive700',
        borderColor: 'transparent',
        '&:focus': {
          backgroundColor: '$destructive50',
          outline: '1px solid $destructive700',
          borderColor: 'transparent',
        },
      },
    },
  },
};

export const inputBreakpointStyles = {
  padding: '6px 12px',
  width: 248,
  height: 30,
  '@tablet': {
    padding: '10px 12px',
    width: 338,
    height: 40,
  },
  variants: {
    isModal: {
      true: {
        width: 311,
        height: 38,
        '@tablet': {
          width: 372,
          height: 40,
        },
      },
    },
  },
};

export const textAreaBreakpointStyles = {
  default: {
    width: 248,
    height: 84,
    padding: '6px 12px',
  },
  tablet: {
    width: 338,
    height: 100,
    padding: '10px 12px',
  },
};

export const TextAreaContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: 4,
  fontSize: 14,
  '@tablet': {
    gap: 8,
    fontSize: 16,
  },
});

export const TextInputContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  width: 248,
  gap: 4,
  fontSize: 14,
  '@tablet': {
    width: 338,
    gap: 8,
    fontSize: 16,
  },
  variants: {
    isModal: {
      true: {
        width: 311,
        '@tablet': {
          width: 372,
        },
      },
    },
  },
});
